import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { FormItemTypes, MLHelper } from '@bimser/core';

export function getControlData(item: LayoutCreatorEntities.LayoutItem) {
	switch (item.type) {
		case FormItemTypes.EControlTypes.NumberBox:
		case FormItemTypes.EControlTypes.SearchBox:
		case FormItemTypes.EControlTypes.MaskInput:
		case FormItemTypes.EControlTypes.DateRangePicker:
		case FormItemTypes.EControlTypes.DocumentMetadata:
		case FormItemTypes.EControlTypes.FormMetadata:
		case FormItemTypes.EControlTypes.UserMetadata:
		case FormItemTypes.EControlTypes.Barcode:
		case FormItemTypes.EControlTypes.Password:
		case FormItemTypes.EControlTypes.Slider:
		case FormItemTypes.EControlTypes.Rate:
		case FormItemTypes.EControlTypes.TimePicker:
		case FormItemTypes.EControlTypes.DateTimePicker:
			return getDateTimePickerValue(item);
		case FormItemTypes.EControlTypes.TextArea:
		case FormItemTypes.EControlTypes.TextBox:
		case FormItemTypes.EControlTypes.ProtectedTextBox:
		case FormItemTypes.EControlTypes.HTMLTextBox:
			return getHTMLTextboxValue(item);
		case FormItemTypes.EControlTypes.Radio:
		case FormItemTypes.EControlTypes.Switch:
		case FormItemTypes.EControlTypes.CheckBox:
			return getCheckBoxValue(item);
		case FormItemTypes.EControlTypes.Lookup:
		case FormItemTypes.EControlTypes.TagBox:
		case FormItemTypes.EControlTypes.ListBox:
			return getListBoxValue(item);
		case FormItemTypes.EControlTypes.RadioList:
		case FormItemTypes.EControlTypes.ComboBox:
			return getComboBoxValue(item);
		case FormItemTypes.EControlTypes.TreeSelect:
		case FormItemTypes.EControlTypes.TreeView:
			return getTreeViewValue(item);
		case FormItemTypes.EControlTypes.DateRangePicker:
			return getDateRangePickerValue(item);
		case FormItemTypes.EControlTypes.DataGrid:
			return getDataGridValue(item);
		case FormItemTypes.EControlTypes.RelatedDocuments:
			return getRelatedDocumentsValue(item);
		default:
			return { value: null, text: null };
	}
}

function getDateTimePickerValue(item: LayoutCreatorEntities.LayoutItem) {
	return {
		text: MLHelper.getMLText(item.getIn(['properties', 'text'])) || '',
		value: item.getIn(['properties', 'value']) || null
	};
}

function getHTMLTextboxValue(item: LayoutCreatorEntities.LayoutItem) {
	return {
		text: item.getIn(['properties', 'multiLanguageText']) || { system: '' },
		value: item.getIn(['properties', 'multiLanguageText']) || { system: '' }
	};
}

function getCheckBoxValue(item: LayoutCreatorEntities.LayoutItem) {
	return {
		text: MLHelper.getMLText(item.getIn(['properties', 'text'])) || '',
		value: item.getIn(['properties', 'value']) || false
	};
}

function getListBoxValue(item: LayoutCreatorEntities.LayoutItem) {
	const selectedItems = item.getIn(['properties', 'items'])?.filter(_item => _item.selected);
	return {
		text: selectedItems?.map(_item => MLHelper.getMLText(_item.text))?.join(',') || '',
		value: selectedItems?.map(_item => _item.value) || []
	};
}

function getComboBoxValue(item: LayoutCreatorEntities.LayoutItem) {
	const selectedItems = item.getIn(['properties', 'items'])?.filter(_item => _item.selected);
	return {
		text: selectedItems?.map(_item => MLHelper.getMLText(_item.text))?.join(',') || '',
		value: selectedItems[0]?.value || null
	};
}

function getRelatedDocumentsValue(item: LayoutCreatorEntities.LayoutItem) {
	return {
		text: MLHelper.getMLText(item.getIn(['properties', 'text'])) || '',
		value: item.getIn(['properties', 'files']) || null
	};
}

function getValueForTreeControls(item: LayoutCreatorEntities.LayoutItem) {
	if (item.getIn(['properties', 'selectedItems'])?.length) {
		return item.getIn(['properties', 'selectedItems']).map(selectedItem => selectedItem.value);
	} else if (
		(item.get('type') === FormItemTypes.EControlTypes.TreeView &&
			item.getIn(['properties', 'selection', 'mode']) === 'single') ||
		(item.get('type') === FormItemTypes.EControlTypes.TreeSelect &&
			!item.getIn(['properties', 'multiple']))
	) {
		return null;
	}
	return [];
}

function getTreeViewValue(item: LayoutCreatorEntities.LayoutItem) {
	const texts =
		item
			.getIn(['properties', 'selectedItems'])
			?.map(selectedItem => MLHelper.getMLText(selectedItem.text))
			?.join(',') || '';
	const values = getValueForTreeControls(item);
	return {
		text: texts,
		value: values
	};
}

function getDateRangePickerValue(item: LayoutCreatorEntities.LayoutItem) {
	const startDate = item.getIn(['properties', 'startDate', 'value']);
	const endDate = item.getIn(['properties', 'endDate', 'value']);

	return {
		text: [startDate || '', endDate || ''].join(',') || '',
		value: [startDate || null, endDate || null]
	};
}

function getDataGridValue(item: LayoutCreatorEntities.LayoutItem) {
	if (!item.getIn(['properties', 'dataSource', 'name'])) {
		return { text: '', value: item.getIn(['properties', 'rows']) };
	}
	return {
		value: null,
		text: null
	};
}
